<div class="forgot-password-container">
  <mat-card class="forgot-password-card">
    <mat-card-title>
      {{ tipo === 'senha' ? 'RecuperaÃ§Ã£o de Senha' : 'RecuperaÃ§Ã£o de UsuÃ¡rio' }}
    </mat-card-title>

    <mat-card-content>
      <p>
        Informe seu e-mail cadastrado para receber
        {{ tipo === 'senha' ? 'um link de redefiniÃ§Ã£o de senha.' : 'seu nome de usuÃ¡rio.' }}
      </p>

      <form (ngSubmit)="solicitarInformacao()" #form="ngForm">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            required
            (input)="email.set($any($event.target).value)" />

          @if (email() && !emailValido()) {
            <mat-error>Insira um e-mail vÃ¡lido.</mat-error>
          }
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          class="full-width"
          type="submit"
          [disabled]="!emailValido()">
          Enviar
        </button>
      </form>

      <div style="text-align: center; margin-top: 20px;">
        <button mat-stroked-button color="primary" routerLink="/login">
          â Voltar para a pÃ¡gina de login
        </button>
      </div>

      <div *ngIf="mensagemSucesso()" class="mensagem sucesso">
        {{ mensagemSucesso() }}
      </div>

      <div *ngIf="mensagemErro()" class="mensagem erro">
        {{ mensagemErro() }}
      </div>
    </mat-card-content>
  </mat-card>
</div>